import React, { Component } from 'react';
import Draggable from "react-draggable";
import SelectorModel from "./SelectorModel";

export default class SelectorDraggable extends Component {

    state = {
        model: new SelectorModel({
            pointerEvents: 'auto',
            borderWidth: 3,
            borderColor: "#218dfd",
        })
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

    }

    componentWillUnmount() {

    }

    // onDoubleClick(e) {
    //     this.props.model.isEdit = true;
    // }

    onDrag = (e, position) => {

        if (this.props.designer.properties.isDiagramLinking)
            return;
        if (position === "center") {
            this.props.designer.PluginDragMove.onDragMove(e);
            return;
        }

        if (!this.dragStartPoint)
            return;

        const x = e.screenX;
        const y = e.screenY;
        const dx = x - this.dragStartPoint.x;
        const dy = y - this.dragStartPoint.y;

        const res = this.props.designer.resolution;
        const scale = this.props.model.scale;
        const parentScale = this.props.model._sys.parent ? this.props.model._sys.parent.getViewScale() : 1;
        const mx = dx * res / parentScale;
        const my = dy * res / parentScale;

        const model = this.props.model;
        if (position === 'center') {
            model.x = Math.round(this.modelRectBackup.x + mx);
            model.y = Math.round(this.modelRectBackup.y + my);
        }
        else if (position === 'rb') {
            const w = Math.round(this.modelRectBackup.width + mx / scale);
            const h = Math.round(this.modelRectBackup.height + my / scale);
            model.width = w < 0 ? 0 : w;
            model.height = h < 0 ? 0 : h;
        }
        else if (position === 'r') {
            const w = Math.round(this.modelRectBackup.width + mx / scale);
            model.width = w < 0 ? 0 : w;
        }
        else if (position === 'b') {
            const h = Math.round(this.modelRectBackup.height + my / scale);
            model.height = h < 0 ? 0 : h;
        }
        else if (position === 'lb') {
            let w = Math.round(this.modelRectBackup.width - mx / scale);
            let h = Math.round(this.modelRectBackup.height + my / scale);
            w = w < 0 ? 0 : w;
            h = h < 0 ? 0 : h;
            model.width = w;
            model.height = h;
            model.x = this.modelRectBackup.rs - w * scale;
        }
        else if (position === 'l') {
            let w = Math.round(this.modelRectBackup.width - mx / scale);
            w = w < 0 ? 0 : w;
            model.width = w;
            model.x = this.modelRectBackup.rs - w * scale;
        }
        else if (position === 'lt') {
            let w = Math.round(this.modelRectBackup.width - mx / scale);
            let h = Math.round(this.modelRectBackup.height - my / scale);
            w = w < 0 ? 0 : w;
            h = h < 0 ? 0 : h;
            model.width = w;
            model.height = h;
            model.x = this.modelRectBackup.rs - w * scale;
            model.y = this.modelRectBackup.bs - h * scale;
        }
        else if (position === 't') {
            let h = Math.round(this.modelRectBackup.height - my / scale);
            h = h < 0 ? 0 : h;
            model.height = h;
            model.y = this.modelRectBackup.bs - h * scale;
        }
        else if (position === 'rt') {
            const w = Math.round(this.modelRectBackup.width + mx / scale);
            let h = Math.round(this.modelRectBackup.height - my / scale);
            h = h < 0 ? 0 : h;
            model.width = w < 0 ? 0 : w;
            model.height = h;
            model.y = this.modelRectBackup.bs - h * scale;
        }
    };

    onDragStart = (e, position) => {

        if (this.props.designer.properties.isDiagramLinking)
            return;
        if (position === "center") {
            this.props.designer.PluginDragMove.onDragMoveStart(e);
            return;
        }

        this.props.designer.properties.isDiagramDragging = true;
        this.dragStartPoint = {
            x: e.screenX,
            y: e.screenY
        }

        const size = this.props.model.getViewSize();

        this.modelRectBackup = {
            x: this.props.model.x,
            y: this.props.model.y,
            width: size.width,
            height: size.height,
            widths: size.width * this.props.model.scale,
            heights: size.height * this.props.model.scale,
            r: this.props.model.x + size.width,
            b: this.props.model.y + size.height,
            rs: this.props.model.x + size.width * this.props.model.scale,
            bs: this.props.model.y + size.height * this.props.model.scale,
        }
    }

    onDragStop = (e, position) => {

        if (this.props.designer.properties.isDiagramLinking)
            return;
        if (position === "center") {
            this.props.designer.PluginDragMove.onDragMoveStop(e);
            return;
        }

        this.props.designer.properties.isDiagramDragging = false;
        this.dragStartPoint = null;
        this.modelRectBackup = null;
    }

    renderDraggable() {

        return this.props.designer.selectedItems.length === 1 ? [
            <Draggable
                key="center"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'center')}
                onDrag={e => this.onDrag(e, 'center')}
                onStop={e => this.onDragStop(e, 'center')}>
                <div className="center">
                </div>
            </Draggable>,
            <Draggable
                key="lt"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'lt')}
                onDrag={e => this.onDrag(e, 'lt')}
                onStop={e => this.onDragStop(e, 'lt')}>
                <div className="sizer lt">
                </div>
            </Draggable>,
            <Draggable
                key="t"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 't')}
                onDrag={e => this.onDrag(e, 't')}
                onStop={e => this.onDragStop(e, 't')}>
                <div className="sizer t">
                </div>
            </Draggable>,
            <Draggable
                key="l"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'l')}
                onDrag={e => this.onDrag(e, 'l')}
                onStop={e => this.onDragStop(e, 'l')}>
                <div className="sizer l">
                </div>
            </Draggable>,
            <Draggable
                key="lb"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'lb')}
                onDrag={e => this.onDrag(e, 'lb')}
                onStop={e => this.onDragStop(e, 'lb')}>
                <div className="sizer lb">
                </div>
            </Draggable>,
            <Draggable
                key="b"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'b')}
                onDrag={e => this.onDrag(e, 'b')}
                onStop={e => this.onDragStop(e, 'b')}>
                <div className="sizer b">
                </div>
            </Draggable>,
            <Draggable
                key="rt"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'rt')}
                onDrag={e => this.onDrag(e, 'rt')}
                onStop={e => this.onDragStop(e, 'rt')}>
                <div className="sizer rt">
                </div>
            </Draggable>,
            <Draggable
                key="r"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'r')}
                onDrag={e => this.onDrag(e, 'r')}
                onStop={e => this.onDragStop(e, 'r')}>
                <div className="sizer r">
                </div>
            </Draggable>,
            <Draggable
                key="rb"
                position={{ x: 0, y: 0 }}
                onStart={e => this.onDragStart(e, 'rb')}
                onDrag={e => this.onDrag(e, 'rb')}
                onStop={e => this.onDragStop(e, 'rb')}>
                <div className="sizer rb">
                </div>
            </Draggable>
        ] :
            (
                <Draggable
                    key="center"
                    position={{ x: 0, y: 0 }}
                    onStart={e => this.onDragStart(e, 'center')}
                    onDrag={e => this.onDrag(e, 'center')}
                    onStop={e => this.onDragStop(e, 'center')}>
                    <div className="center">
                    </div>
                </Draggable>
            );

    }

    render() {

        return (
            <div className={"selector-ui selector-draggable"} style={this.state.model.toStyle()}>
                {this.renderDraggable()}
            </div>
        );
    }
}
